import { useContext } from "react";
import type { RootStore } from "./index";
import { RootStoreContext } from "./index";

export const useRootStore = (): RootStore => useContext(RootStoreContext);
